import React, { FC, useState } from "react";
import SettingsSubmitButton from "./settingsSubmitButton";
import { Redirect } from "react-router-dom";
import SettingsTitle from "./settingsTitle";
import CommonModal from "../../../shared/components/commonModal";

type Props = {
  message: string;
  onDelete: () => Promise<void>;
};

const SettingsDelete: FC<Props> = ({ message, onDelete }) => {
  const [errors, setErrors] = useState<string[]>([]);
  const [redirect, setRedirect] = useState<boolean>(false);
  
  const save = async () => {
    return onDelete()
      .then(() => {
        setRedirect(true);
      })
      .catch((error) =>{
        const errorMessage = error instanceof Error ? error.message : "An error occurred while deleting.";
        setErrors([errorMessage]);
      });
  }

  if (redirect) return <Redirect to={`../list`} />;
  return (
    <CommonModal
      show={true}
      onHide={()=>setRedirect(true)}
      title={message}
      buttons={
        <>
          <button className="btn btn-secondary" onClick={() => setRedirect(true)}>
            Close
          </button>
          <SettingsSubmitButton buttonText="Yes" onSave={save} />
        </>
      }
    >
      <SettingsTitle title="" errors={errors} />
      {message}
    </CommonModal>
  );
}
export default SettingsDelete;
